import { SchemaFieldType, SchemaFieldTypeExtended } from "config/config";
import { operatorsList } from "./constants";

export const getMatchingSchema = (allFields: SchemaFieldTypeExtended[], value: string) =>
    allFields?.find((matchingField) => matchingField.name === value);

export const eqTrueOp = "eqTrue";
export const eqFalseOp = "eqFalse";
export const isBooleanTypeOperator = (op) => op === eqTrueOp || op === eqFalseOp;
export const isNullableOperator = (op) => op === "set" || op === "unset";

export const getOperatorList = (matchingSchema?: SchemaFieldType) => {
    const getOpList = (possibleValues) =>
        operatorsList.filter((op) => possibleValues.includes(op.value));

    let opList: { value: string; label: string }[] = [];
    switch (matchingSchema?.type) {
        case "bool":
            opList = [
                { value: eqTrueOp, label: "True" },
                { value: eqFalseOp, label: "False" },
            ];
            break;
        case "str":
            if (matchingSchema.foreign_keys.length) {
                opList = getOpList(["eq", "neq", "in", "notin"]);
            } else if (matchingSchema.schema?.["format"] === "uuid") {
                opList = getOpList(["eq", "neq"]);
            } else if (Array.isArray(matchingSchema.schema?.["enum"])) {
                // Enum-backed strings (ALLOWED_VALUES object-template attributes such as
                // operator-task.status) are a fixed picklist, so offer exact match plus
                // multi-value membership. The enum value control (ValueField) already
                // renders a multi-select for the `in`/`notin` operators.
                opList = getOpList(["eq", "neq", "in", "notin"]);
            } else {
                opList = getOpList(["like", "notlike", "eq", "neq"]);
            }
            break;
        case "datetime":
            opList = [
                { value: "eq", label: "Is" },
                { value: "gt", label: "After" },
                { value: "lt", label: "Before" },
            ];
            break;
        case "int":
            opList = getOpList(["lt", "lte", "gt", "gte", "eq", "neq", "in", "notin"]);
            break;
        case "dict":
            opList = getOpList(["eq", "neq"]);
            break;
        case "list":
            opList = getOpList(["in", "notin"]);
            break;
        default:
            if (
                matchingSchema?.type &&
                (/Type$/.test(matchingSchema.type) ||
                    /Status$/.test(matchingSchema.type) ||
                    /ProvisioningState$/.test(matchingSchema.type))
            ) {
                opList = getOpList(["eq", "neq", "in", "notin"]);
            }
            break;
    }
    if (matchingSchema?.nullable) {
        const nullOp = getOpList(["set", "unset"]);
        opList.push(...nullOp);
    }
    return opList;
};

export const isArrayOperator = (operator: string) => operator === "in" || operator === "notin";
